import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/i2k2admin/RestroAgent/RestroAgent/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/i2k2admin/RestroAgent/RestroAgent/src/client/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/i2k2admin/RestroAgent/RestroAgent/src/client/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/i2k2admin/RestroAgent/RestroAgent/src/styles/tailwind.css");
